import { useEffect, useState } from 'react';

import { messages } from '@qality/common-messages';
import { Issue } from '@qality/common-model';
import { IssueService, StorageOfUniqueServices } from '@qality/common-service';

export default function useFetchTestCaseIssue(
  testCaseId: number,
  shouldFetchOnInit = true
) {
  const [testCaseIssue, setTestCaseIssue] = useState<Issue>();
  const [isLoading, setIsLoading] = useState(true);
  const [errorType, setErrorType] = useState<'no-permission' | 'unexpected'>();

  useEffect(() => {
    if (shouldFetchOnInit) {
      fetchTestCaseIssue(testCaseId);
    }
  }, [shouldFetchOnInit]);

  const fetchTestCaseIssue = async (issueId: number): Promise<void> => {
    try {
      const issue = await IssueService.getIssue(issueId.toString());
      setTestCaseIssue(issue);
    } catch (error) {
      if (error?.xhr?.status === 404) {
        setErrorType('no-permission');
        return;
      }

      setErrorType('unexpected');
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        error,
        messages['error.executeTestCase.message']
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { fetchTestCaseIssue, testCaseIssue, isLoading, errorType };
}
